export const CustomerCountry: {
    GERMANY: 'GERMANY',
    FRANCE: 'FRANCE',
    ITALY: 'ITALY',
    SPAIN: 'SPAIN',
    PORTUGAL: 'PORTUGAL',
    NETHERLANDS: 'NETHERLANDS',
    BELGIUM: 'BELGIUM',
    LUXEMBOURG: 'LUXEMBOURG',
    SWITZERLAND: 'SWITZERLAND',
    AUSTRIA: 'AUSTRIA',
    UNITED_KINGDOM: 'UNITED_KINGDOM',
    IRELAND: 'IRELAND',
    DENMARK: 'DENMARK',
    NORWAY: 'NORWAY',
    SWEDEN: 'SWEDEN',
    FINLAND: 'FINLAND',
    ENGLAND: 'ENGLAND',
    SCOTLAND: 'SCOTLAND',
    WALES: 'WALES',
    NORTHERN_IRELAND: 'NORTHERN_IRELAND',
    UNITED_STATES: 'UNITED_STATES',
    CANADA: 'CANADA'
} = {
    GERMANY: 'GERMANY',
    FRANCE: 'FRANCE',
    ITALY: 'ITALY',
    SPAIN: 'SPAIN',
    PORTUGAL: 'PORTUGAL',
    NETHERLANDS: 'NETHERLANDS',
    BELGIUM: 'BELGIUM',
    LUXEMBOURG: 'LUXEMBOURG',
    SWITZERLAND: 'SWITZERLAND',
    AUSTRIA: 'AUSTRIA',
    UNITED_KINGDOM: 'UNITED_KINGDOM',
    IRELAND: 'IRELAND',
    DENMARK: 'DENMARK',
    NORWAY: 'NORWAY',
    SWEDEN: 'SWEDEN',
    FINLAND: 'FINLAND',
    ENGLAND: 'ENGLAND',
    SCOTLAND: 'SCOTLAND',
    WALES: 'WALES',
    NORTHERN_IRELAND: 'NORTHERN_IRELAND',
    UNITED_STATES: 'UNITED_STATES',
    CANADA: 'CANADA'
};

export type CustomerCountry = (typeof CustomerCountry)[keyof typeof CustomerCountry]